import { render, staticRenderFns } from "./AdminAvailabilityBookings.vue?vue&type=template&id=238c1dae"
import script from "./AdminAvailabilityBookings.vue?vue&type=script&lang=js"
export * from "./AdminAvailabilityBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports